module.exports = __webpack_public_path__ + "static/media/Icon_Schlittschuhe.d7f4d5d0.png";